var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"cols":"3"}},[_vm._v(" "+_vm._s(_vm.$t('login.wait'))+" "),_c('v-progress-linear',{attrs:{"indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }